import PropTypes from 'prop-types';
import React from 'react';
import { connect, useDispatch } from 'react-redux';

import cls from 'classnames/bind';

import { useGoogleLogin } from '@react-oauth/google';

import { useAppleLogin } from '../../../../hooks/useAppleLogin';
import { getOAuthInfo } from '../../../../redux/auth/actions';
import { APPLE, GOOGLE } from '../../constants';
import { getPreparedLocale } from './helpers';

import styles from './SocialItem.scss';

const SocialItem = ({ name, icon, dataLocator }) => {
  const dispatch = useDispatch();

  const {
    login: appleLogin,
    loaded: isAppleOAuthLoaded,
    error: appleError,
  } = useAppleLogin({
    locale: getPreparedLocale(),
    onSuccess: (response) => {
      const {
        authorization: { code },
      } = response;

      if (code) {
        dispatch(
          getOAuthInfo({
            provider: name,
            code,
          })
        );
      }
    },
  });

  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      const { code } = codeResponse;

      if (code) {
        dispatch(
          getOAuthInfo({
            provider: name,
            token: code,
          })
        );
      }
    },
    onError: (errorResponse) => errorResponse,
  });

  const auth = () => {
    if (name === APPLE) {
      appleLogin();
    } else if (name === GOOGLE) {
      googleLogin();
    } else {
      const today = new Date();

      const oAuthModal = window.open(
        '',
        `sharer_${today.getTime()}`,
        'toolbar=no,width=980,height=500,modal=yes'
      );

      dispatch(getOAuthInfo({ provider: name, oAuthModal }));
    }
  };

  if (name === APPLE && (!isAppleOAuthLoaded || appleError)) {
    return null;
  }

  return (
    <button
      type="button"
      disabled={name === APPLE && (!isAppleOAuthLoaded || appleError)}
      onClick={auth}
      className={cls(styles.item, styles[`item--${name}`])}
      data-locator={dataLocator}
    >
      {icon}
    </button>
  );
};

SocialItem.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.element,
  dataLocator: PropTypes.string,
};

export default connect()(SocialItem);
